// Source: https://thenounproject.com/icon/triangle-up-1461890/

export const TriangleUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="1200pt"
    height="1200pt"
    version="1.1"
    viewBox="0 0 1200 1200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m136.77 889.32 463.23-578.64 463.23 578.64z" />
  </svg>
);
